import { createContext, useContext, useEffect, useState } from "react";
import { api } from "../lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
    const [admin, setAdmin] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const token = localStorage.getItem("admin_token");
        if (!token) { setLoading(false); return; }
        api.get("/admin/me").then((r) => setAdmin(r.data)).catch(() => {
            localStorage.removeItem("admin_token");
        }).finally(() => setLoading(false));
    }, []);

    const login = async (email, password) => {
        const r = await api.post("/admin/login", { email, password });
        localStorage.setItem("admin_token", r.data.token);
        setAdmin({ email: r.data.email });
        return true;
    };

    const logout = () => {
        localStorage.removeItem("admin_token");
        setAdmin(null);
    };

    return (
        <AuthContext.Provider value={{ admin, login, logout, loading }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
